import {
  cibCcAmex,
  cibCcApplePay,
  cibCcMastercard,
  cibCcPaypal,
  cibCcStripe,
  cibCcVisa,
  cibFacebook,
  cibGoogle,
  cibCss3,
  cibLinkedin,
  cibSkype,
  cibTwitter,
  cibZapier,
  cifBr,
  cifEs,
  cifFr,
  cifIn,
  cifPl,
  cifUs,
  cilAlarm,
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilApplicationsSettings,
  cilAccountLogout,
  cilArrowBottom,
  cilArrowRight,
  cilArrowTop,
  cilBasket,
  cilBell,
  cilBold,
  cilBookmark,
  cilBriefcase,
  cilBullhorn,
  cilCalculator,
  cilCalendar,
  cilCarAlt,
  cilChart,
  cilChartPie,
  cilCheck,
  cilChevronLeft,
  cilChevronRight,
  cilChevronBottom,
  cilChevronDoubleUp,
  cilClock,
  cilCloudDownload,
  cilCode,
  cilCog,
  cilCommentSquare,
  cilCreditCard,
  cilCursor,
  cilDollar,
  cilDrop,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilFile,
  cilGarage,
  cilGlobeAlt,
  cilGrain,
  cilHome,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilItalic,
  cilJustifyCenter,
  cilLayers,
  cilLifeRing,
  cilList,
  cilListNumbered,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMap,
  cilMediaPlay,
  cilMenu,
  cilMobile,
  cilMoon,
  cilNotes,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPen,
  cilPencil,
  cilPeople,
  cilPrint,
  cilPuzzle,
  cilReload,
  cilReportSlash,
  cilSave,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSun,
  cilTags,
  cilTask,
  cilTrash,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
  cilWarning,
  cilMoney,
  cilLibrary,
  cilInfo,
  cilPlus,
  cilSearch,
  cilSortAscending,
  cilPhone,
  cilUserPlus,
  cilXCircle,
  cilChevronCircleDownAlt,
  cilDescription,
  cilExternalLink,
  cilScreenSmartphone,
  cibReadTheDocs,
  cibCodacy,
  cilMediaStepBackward,
  cilCloudUpload,
  cilFeaturedPlaylist,
  cilLoop,
  cilDialpad,
  cilLink

} from '@coreui/icons';



export const iconSubset = {
  cibCcAmex,
  cibCcApplePay,
  cibCcMastercard,
  cibCcPaypal,
  cibCcStripe,
  cibCcVisa,
  cibFacebook,
  cibGoogle,
  cibCss3,
  cibLinkedin,
  cibSkype,
  cibTwitter,
  cibZapier,
  cifBr,
  cifEs,
  cifFr,
  cifIn,
  cifPl,
  cifUs,
  cilAccountLogout,
  cilAlarm,
  cilAlignCenter,
  cilAlignLeft,
  cilAlignRight,
  cilApplicationsSettings,
  cilArrowBottom,
  cilArrowRight,
  cilArrowTop,
  cilBasket,
  cilBell,
  cilBold,
  cilBookmark,
  cilBriefcase,
  cilBullhorn,
  cilCalculator,
  cilCalendar,
  cilCarAlt,
  cilChart,
  cilChartPie,
  cilCheck,
  cilChevronLeft,
  cilChevronRight,
  cilChevronBottom,
  cilChevronDoubleUp,
  cilCloudDownload,
  cilClock,
  cilCode,
  cilCog,
  cilCommentSquare,
  cilCreditCard,
  cilCursor,
  cilDollar,
  cilDrop,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilFile,
  cilGarage,
  cilGlobeAlt,
  cilGrain,
  cilHome,
  cilInbox,
  cilIndentDecrease,
  cilIndentIncrease,
  cilItalic,
  cilJustifyCenter,
  cilLayers,
  cilLifeRing,
  cilList,
  cilListNumbered,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMap,
  cilMediaPlay,
  cilMenu,
  cilMobile,
  cilMoon,
  cilNotes,
  cilOptions,
  cilPaperclip,
  cilPaperPlane,
  cilPen,
  cilPencil,
  cilPeople,
  cilPrint,
  cilPuzzle,
  cilReload,
  cilReportSlash,
  cilSave,
  cilSettings,
  cilShare,
  cilShareAll,
  cilShareBoxed,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
  cilSun,
  cilTags,
  cilTask,
  cilTrash,
  cilUnderline,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilUserUnfollow,
  cilWarning,
  cilMoney,
  cilLibrary,
  cilInfo,
  cilPlus,
  cilSearch,
  cilSortAscending,
  cilPhone,
  cilUserPlus,
  cilXCircle,
  cilChevronCircleDownAlt,
  cilDescription,
  cilExternalLink,
  cilScreenSmartphone,
  cibReadTheDocs,
  cibCodacy,
  cilMediaStepBackward,
  cilCloudUpload,
  cilFeaturedPlaylist,
  cilLoop,
  cilDialpad,
  cilLink

};

export enum IconSubset {
  cibCcAmex = 'cibCcAmex',
  cibCcApplePay = 'cibCcApplePay',
  cibCcMastercard = 'cibCcMastercard',
  cibCcPaypal = 'cibCcPaypal',
  cibCcStripe = 'cibCcStripe',
  cibCcVisa = 'cibCcVisa',
  cibFacebook = 'cibFacebook',
  cibGoogle = 'cibGoogle',
  cibCss3 = 'cibCss3',
  cibLinkedin = 'cibLinkedin',
  cibSkype = 'cibSkype',
  cilAccountLogout = 'cilAccountLogout',
  cilLink = 'cilLink',
  cibTwitter = 'cibTwitter',
  cibZapier = 'cibZapier',
  cifBr = 'cifBr',
  cifEs = 'cifEs',
  cifFr = 'cifFr',
  cifIn = 'cifIn',
  cifPl = 'cifPl',
  cifUs = 'cifUs',
  cilAlarm = 'cilAlarm',
  cilAlignCenter = 'cilAlignCenter',
  cilAlignLeft = 'cilAlignLeft',
  cilAlignRight = 'cilAlignRight',
  cilApplicationsSettings = 'cilApplicationsSettings',
  cilArrowBottom = 'cilArrowBottom',
  cilArrowRight = 'cilArrowRight',
  cilArrowTop = 'cilArrowTop',
  cilBasket = 'cilBasket',
  cilBell = 'cilBell',
  cilBold = 'cilBold',
  cilBookmark = 'cilBookmark',
  cilBriefcase = 'cilBriefcase',
  cilCalculator = 'cilCalculator',
  cilCalendar = 'cilCalendar',
  cilCarAlt = 'cilCarAlt',
  cilChart = 'cilChart',
  cilChartPie = 'cilChartPie',
  cilCheck = 'cilCheck',
  cilChevronLeft = 'cilChevronLeft',
  cilChevronRight = 'cilChevronRight',
  cilChevronBottom = 'cilChevronBottom',
  cilChevronDoubleUp = 'cilChevronDoubleUp',
  cilCloudDownload = 'cilCloudDownload',
  cilClock = 'cilClock',
  cilCode = 'cilCode',
  cilCog = 'cilCog',
  cilCommentSquare = 'cilCommentSquare',
  cilCreditCard = 'cilCreditCard',
  cilCursor = 'cilCursor',
  cilDollar = 'cilDollar',
  cilDrop = 'cilDrop',
  cilEnvelopeClosed = 'cilEnvelopeClosed',
  cilEnvelopeOpen = 'cilEnvelopeOpen',
  cilFile = 'cilFile',
  cilGarage = 'cilGarage',
  cilGlobeAlt = 'cilGlobeAlt',
  cilGrain = 'cilGrain',
  cilHome = 'cilHome',
  cilInbox = 'cilInbox',
  cilIndentDecrease = 'cilIndentDecrease',
  cilIndentIncrease = 'cilIndentIncrease',
  cilItalic = 'cilItalic',
  cilJustifyCenter = 'cilJustifyCenter',
  cilLayers = 'cilLayers',
  cilLifeRing = 'cilLifeRing',
  cilList = 'cilList',
  cilListNumbered = 'cilListNumbered',
  cilLocationPin = 'cilLocationPin',
  cilLockLocked = 'cilLockLocked',
  cilMagnifyingGlass = 'cilMagnifyingGlass',
  cilMap = 'cilMap',
  cilMediaPlay = 'cilMediaPlay',
  cilMenu = 'cilMenu',
  cilMobile = 'cilMobile',
  cilMoon = 'cilMoon',
  cilNotes = 'cilNotes',
  cilOptions = 'cilOptions',
  cilPaperclip = 'cilPaperclip',
  cilPaperPlane = 'cilPaperPlane',
  cilPen = 'cilPen',
  cilPencil = 'cilPencil',
  cilPeople = 'cilPeople',
  cilPrint = 'cilPrint',
  cilPuzzle = 'cilPuzzle',
  cilReload = 'cilReload',
  cilReportSlash = 'cilReportSlash',
  cilSave = 'cilSave',
  cilSettings = 'cilSettings',
  cilShare = 'cilShare',
  cilShareAll = 'cilShareAll',
  cilShareBoxed = 'cilShareBoxed',
  cilShieldAlt = 'cilShieldAlt',
  cilSpeech = 'cilSpeech',
  cilSpeedometer = 'cilSpeedometer',
  cilSpreadsheet = 'cilSpreadsheet',
  cilStar = 'cilStar',
  cilSun = 'cilSun',
  cilTags = 'cilTags',
  cilTask = 'cilTask',
  cilTrash = 'cilTrash',
  cilUnderline = 'cilUnderline',
  cilUser = 'cilUser',
  cilUserFemale = 'cilUserFemale',
  cilUserFollow = 'cilUserFollow',
  cilUserUnfollow = 'cilUserUnfollow',
  cilWarning = 'cilWarning',
  cilMoney = 'cilMoney',
  cilLibrary = 'cilLibrary',
  cilInfo = 'cilInfo',
  cilPlus = 'cilPlus',
  cilSearch = 'cilSearch',
  cilSortAscending = 'cilSortAscending',
  cilPhone = 'cilPhone',
  cilUserPlus = 'cilUserPlus',
  cilXCircle = 'cilXCircle',
  cilChevronCircleDownAlt = 'cilChevronCircleDownAlt',
  cilDescription = 'cilDescription',
  cilExternalLink = 'cilExternalLink',
  cilScreenSmartphone = 'cilScreenSmartphone',
  cibReadTheDocs = 'cibReadTheDocs',
  cibCodacy = 'cibCodacy',
  cilMediaStepBackward = 'cilMediaStepBackward',
  cilCloudUpload = 'cilCloudUpload',
  cilFeaturedPlaylist = 'cilFeaturedPlaylist',
  cilLoop = 'cilLoop',
  cilDialpad = 'cilDialpad'

}
